export default class TabelaColunaUtils {
	sortable = false
	text = 'Texto'
	value = 'Valor'
	width = '5%'
	align = 'start'
	class = 'primary--text'

	constructor(texto, valor, width, align = 'start', sortable = false) {
		this.text = texto
		this.value = valor
		this.width = width
		this.align = align
		this.sortable = sortable
	}
}
